module.exports = __webpack_public_path__ + "img/user.622aa1b3.svg";